export default "__VITE_ASSET__CsbXwhYY__"